import { Component, OnInit } from '@angular/core';
import { Location, UpperCasePipe } from "@angular/common";
import {GlobalService} from "../../../services/global.service";
import {LoaderService} from "../../../services/loader.service";
import {ManageErrorService} from "../../../services/manage-error.service";
import {NotificationService} from "../../../services/notification.service";
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {ModalRoleEnum} from "../../enums/modal-enum";
import { IonToolbar, IonTitle, IonLabel, IonRadioGroup, IonItem, IonRadio, IonGrid, IonRow, IonCol, IonButton, ModalController } from '@ionic/angular/standalone';
import {Studente} from "../../interfaces/studente-figlio.interface";
import {StudentiMensaService} from "../../../features/cittadino/mensa/studenti/studenti-mensa.service";
import {mapDiscoveryToStudente} from "../../../features/cittadino/mensa/studenti/map-discovery-studente";
import { TranslocoModule, TranslocoService, provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'app-choose-child-modal',
    templateUrl: './choose-child-modal.component.html',
    styleUrls: ['./choose-child-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonRadioGroup, IonItem, IonRadio, IonGrid, IonRow, IonCol, IonButton, FormsModule, ReactiveFormsModule, UpperCasePipe, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class ChooseChildModalComponent  implements OnInit {

  opzioniFigli: Array<Studente>;
  currentStudente: Studente | undefined;
  ctrlStudente = new FormControl<Studente | null | undefined>(null);

  get modalTitle(): string { return this.transloco.translate('shared.choose_child.title'); }
  get confirmButtonText(): string { return this.transloco.translate('common.action.confirm'); }
  get cancelButtonText(): string { return this.transloco.translate('common.action.cancel'); }
  get modalMessage(): string { return this.transloco.translate('shared.choose_child.message'); }

  constructor(private location: Location,
              private globalService: GlobalService,
              private studentiMensa: StudentiMensaService,
              private loaderService: LoaderService,
              private manageErrorService: ManageErrorService,
              private notificationService: NotificationService,
              private transloco: TranslocoService,
              private modalController: ModalController) {
    // Sorgente = discovery viva (mappata a `Studente` per il rendering), non più il legacy
    // `opzioniStudenti`. Vedi change `repoint-command-palette-discovery`.
    const righe = this.studentiMensa.studenti ?? [];
    this.opzioniFigli = righe.map(mapDiscoveryToStudente);
    const selId = this.studentiMensa.selezionato?.id;
    this.currentStudente = selId ? this.opzioniFigli.find(s => s.id === selId) : undefined;
    this.ctrlStudente.setValue(this.currentStudente);
    this.ctrlStudente.setValidators(Validators.required);
    this.ctrlStudente.updateValueAndValidity({emitEvent: false})
  }

  ngOnInit() {

  }
  cancel() {
    return this.modalController.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirm() {
    if(this.ctrlStudente.valid) {
      // Scrive la selezione sulla discovery (sorgente unica): rimappa l'id scelto alla riga DTO.
      const scelto = this.studentiMensa.studenti?.find(r => r.id === this.ctrlStudente.value?.id) ?? null;
      if (scelto) {
        this.studentiMensa.setSelezionato(scelto);
      }
    }
    return this.modalController.dismiss(null, ModalRoleEnum.CONFIRM);
  }
}
